export default [
  // Solo 1 - 1:37

  {m:48, t: 8.5, pos: 4},

  {m:49, t: 1, pos: 3, hold: 3},
  // {m:49, t: 2, pos: 3},
  // {m:49, t: 3, pos: 2},
  {m:49, t: 4, pos: 2, hold: 4},
  // {m:49, t: 5, pos: 5},
  // {m:49, t: 6, pos: 3},
  // {m:49, t: 7, pos: 4},
  {m:49, t: 8, pos: 4},

  {m:50, t: 1, pos: 3, hold: 3},
  // {m:50, t: 2, pos: 3},
  // {m:50, t: 3, pos: 2},
  {m:50, t: 4, pos: 2, hold: 4},
  // {m:50, t: 5, pos: 5},
  // {m:50, t: 6, pos: 3},
  // {m:50, t: 7, pos: 4},
  {m:50, t: 8, pos: 4},

  {m:51, t: 1, pos: 3, hold: 3},
  // {m:51, t: 2, pos: 3},
  // {m:51, t: 3, pos: 2},
  {m:51, t: 4, pos: 1, hold: 4},
  // {m:51, t: 5, pos: 5},
  // {m:51, t: 6, pos: 3},
  // {m:51, t: 7, pos: 4},
  {m:51, t: 8, pos: 4},

  {m:52, t: 1, pos: 3, hold: 3},
  // {m:52, t: 2, pos: 3},
  // {m:52, t: 3, pos: 2},
  {m:52, t: 4, pos: 1, hold: 4},
  // {m:52, t: 5, pos: 5},
  // {m:52, t: 6, pos: 3},
  // {m:52, t: 7, pos: 4},
  {m:52, t: 8, pos: 4},

  {m:53, t: 1, pos: 3, hold: 5},
  // {m:53, t: 2, pos: 3},
  // {m:53, t: 3, pos: 2},
  // {m:53, t: 4, pos: 1},
  // {m:53, t: 5, pos: 5},
  {m:53, t: 6, pos: 5},
  {m:53, t: 7, pos: 4},
  {m:53, t: 8, pos: 3},

  {m:54, t: 1, pos: 4},
  {m:54, t: 2, pos: 5},
  {m:54, t: 3, pos: 3},
  {m:54, t: 4, pos: 3},
  {m:54, t: 4.5, pos: 4, hold: 2.5},
  // {m:54, t: 5, pos: 5},
  // {m:54, t: 6, pos: 5},
  {m:54, t: 7, pos: 3},
  {m:54, t: 8, pos: 1},
  {m:54, t: 8.5, pos: 2, hold: 16.5},

  // m:55 holding
  // m:56 holding
];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_solo_1.js
// module id = 12
// module chunks = 0